import axios from 'axios'
import { API_ROOT } from './api-config'

const capeeshApi = axios.create()

capeeshApi.interceptors.request.use((config) => {
    if (config.url && !config.url.includes('/admin/')) {
        const params = []
        if (!config.url.includes('deviceType=')) params.push('deviceType=Web')
        if (!config.url.includes('appVersion=')) params.push('appVersion=4.0.0')
        if (params.length > 0) {
            const separator = config.url.includes('?') ? '&' : '?'
            config.url = `${config.url}${separator}${params.join('&')}`
        }
    }
    return config
})

capeeshApi.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            const isEmbedRoute = window.location.pathname.startsWith('/student/embed')
            if (isEmbedRoute) {
                return Promise.reject(error)
            }

            localStorage.removeItem('authToken')

            const isStudentRoute = window.location.pathname.startsWith('/student')
            const loginPath = isStudentRoute ? '/student/login' : '/login'

            if (window.location.pathname !== loginPath) {
                window.location.href = loginPath
            }
        }
        return Promise.reject(error)
    }
)

export const makeRanddPostRequest = (urlExtension, data = {}, config) => axios.post(urlExtension, data, config)
export const makePostRequest = (urlExtension, data = {}, config) => capeeshApi.post(API_ROOT + urlExtension, data, config)
export const makeGetRequest = (urlExtension, config) => capeeshApi.get(API_ROOT + urlExtension, config)
export const makePutRequest = (urlExtension, data = {}, config) => capeeshApi.put(API_ROOT + urlExtension, data, config)
export const makeDeleteRequest = (urlExtension, data = {}, config) =>
    capeeshApi.delete(API_ROOT + urlExtension, { ...config, data: data })
export const makePatchRequest = (urlExtension, data = {}, config) => capeeshApi.patch(API_ROOT + urlExtension, data, config)
